import { gql } from "@apollo/client";
import * as MENUS from "constants/menus";
import { Layout, Blocks, Loading } from "features"; // Blocks eventually

import {
  BLOG_INFO_FRAGMENT,
  SITE_SETTINGS_FRAGMENT,
  SEO_CONFIG_FRAGMENT,
  SINGLE_EVENT_FRAGMENT,
  ANIMALS_FRAGMENT,
} from "fragments";
import { NavigationMenu, Hero, TextBlock, EventBlock } from "components";

export default function Component(props) {
  const { data, loading, error } = props;

  if (loading) {
    return <Loading type="page" />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const {
    event,
    headerMenuItems,
    footerMenuItems,
    siteSettings,
    seo: defaultSEO,
    animals: { edges: animals },
  } = data;

  const { social } = defaultSEO;

  const {
    seo,
    title,
    content,
    sidebarOptions,
    flexibleContent: { blocks },
    relatedEvents,
    featuredImage,
  } = event;

  const hasBlocks = blocks && blocks.length > 0;

  const { useSidebar, dogsWidget, donateWidget } =
    sidebarOptions.sidebarOptions;

  const {
    address,
    customAddressLabel,
    phoneNumber,
    logo,
    logoWhite,
    logoAlt,
    cta,
    email,
    turnOnAnnouncements,
    announcements,
  } = siteSettings.siteSettings;

  return (
    <Layout
      headerMenuItems={headerMenuItems}
      footerMenuItems={footerMenuItems}
      siteSettings={siteSettings}
      seo={seo}
      logo={logo}
      logoWhite={logoWhite}
      logoAlt={logoAlt}
      cta={cta}
      twitterUser={defaultSEO.social.twitter.username}
      address={address}
      customAddressLabel={customAddressLabel}
      phoneNumber={phoneNumber}
      email={email}
      social={social}
      turnOnAnnouncements={turnOnAnnouncements}
      useSidebar={useSidebar}
      dogsWidget={dogsWidget}
      donateWidget={donateWidget}
      animals={animals}
      announcements={announcements}
    >
      {hasBlocks ? (
        <Blocks blocks={blocks} />
      ) : (
        <>
          <Hero
            title={title}
            featuredImage={featuredImage?.node}
            variant={`event`}
          />
          {content ? (
            <TextBlock
              paragraphs={[
                {
                  contentAlignment: "left",
                  content: content,
                },
              ]}
              className={`mx-0 text-left`}
            />
          ) : null}
          <EventBlock variant={`details`} event={event} />
        </>
      )}
    </Layout>
  );
}

Component.query = gql`
  query PageData(
    $databaseId: ID!
    $headerLocation: MenuLocationEnum!
    $footerLocation: MenuLocationEnum!
    $asPreview: Boolean
    $first: Int = 3
  ) {
    generalSettings {
      ...BlogInfoFragment
    }
    siteSettings {
      ...SiteSettingsFragment
    }
    seo {
      ...SEOConfigFragment
    }
    event(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      ...SingleEventFragment
    }
    animals(first: $first) {
      ...AnimalsFragment
    }
    headerMenuItems: menuItems(
      where: { location: $headerLocation }
      first: 50
    ) {
      nodes {
        ...NavigationMenuItemFragment
      }
    }
    footerMenuItems: menuItems(
      where: { location: $footerLocation }
      first: 50
    ) {
      nodes {
        ...NavigationMenuItemFragment
      }
    }
  }
  ${BLOG_INFO_FRAGMENT}
  ${SITE_SETTINGS_FRAGMENT}
  ${NavigationMenu.fragments.entry}
  ${SEO_CONFIG_FRAGMENT}
  ${SINGLE_EVENT_FRAGMENT}
  ${ANIMALS_FRAGMENT}
`;

Component.variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    headerLocation: MENUS.PRIMARY_LOCATION,
    footerLocation: MENUS.FOOTER_LOCATION,
    asPreview: ctx?.asPreview,
  };
};
